import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { Suscripcion } from "../models/suscripcion";
import { global } from "../global";
@Injectable({
  providedIn: "root",
})
export class ModeloService {
  apiUrl: string = "";
  licencia: string = "";

  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.apiUrl = global.url + "modelo";
    this.licencia = this.cookieService.get("auth_token"); // Obtén el token de las cookies
  }

  consultarModelosSuscritosUsuario(idUsuario: number): Observable<any> {
    let params = new HttpParams().set("idUsuario", String(idUsuario));
    return this.http.get(`${this.apiUrl}/consultarModelosSuscritosUsuario`, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }

  consultarCarterasSuscritosUsuario(idUsuario: number): Observable<any> {
    let params = new HttpParams().set("idUsuario", String(idUsuario));
    return this.http.get(`${this.apiUrl}/consultarCarterasSuscritosUsuario`, {
      headers: {
        licencia: this.licencia,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }
}
